exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-share-tree{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;min-height:10em;max-height:20em;overflow:auto}.cvat-empty-share-tree>.ant-typography{margin-top:10px}\n", ""]);
